<script setup lang="ts">
import type { SaleAssetBusEntity } from '~/apiClient';
import type { PlatformSaleItemEntity } from '~/types/sale.type';

// PROPS
interface Props {
    sale: PlatformSaleItemEntity;
    assetId?: string;
}

const { sale, assetId } = defineProps<Props>();

// COMPOSABLES
const { isTrustReportEligible } = useTrustReport(() => sale);
const { tt } = useTypedI18n();

// DATA
const asset = computed<SaleAssetBusEntity | undefined>(() => (assetId ? sale.assets.find(_a => _a.id === assetId) : sale.mainAsset));
</script>

<template>
    <div v-if="isTrustReportEligible" class="bg-primary-50 flex flex-col gap-6 rounded-xl border border-neutral-300 p-6">
        <div>
            <p class="text-highlighted text-xl font-bold md:text-3xl">
                {{ asset?.brand.brandValue }} {{ asset?.model.modelValue }} <span class="text-primary">TrustReport by Fleequid</span>
            </p>
            <p v-if="asset?.assignee" class="mt-1 text-sm">
                {{ tt('sdp.trustReport.inspectedBy') }}
                <span class="font-bold">{{ asset.assignee.firstname }} {{ asset.assignee.lastname }}</span>
            </p>
        </div>
        <p>{{ tt('sdp.trustReport.description') }}</p>
        <slot />
    </div>

    <slot v-else />
</template>
